module.exports = __webpack_public_path__ + "static/woori_img01@2x-4e370ecc23b0ddc1ef10464147e37866.jpg";